import { c as _c } from "react/compiler-runtime";
import { ProgressBarLink } from "@/components/progress-bar";
import { Button, Divider } from "@/components/ui";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatName } from "@/lib/format-data";
import { ChatBase } from "@/types/chat";
interface Props {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  chat: ChatBase;
  onSelectPrimaryPatient: (patientId: string) => void;
}
export default function SelectPrimaryPatientModal(t0) {
  const $ = _c(29);
  const {
    isOpen,
    setIsOpen,
    chat,
    onSelectPrimaryPatient
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogTitle className="text-h3 font-medium">Select Primary Patient</DialogTitle>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    t3 = <br />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DialogHeader className="space-y-4">{t1}<DialogDescription className="text-body leading-relaxed text-foreground-secondary">This chat involves multiple patients sharing the same phone number. Please select a primary patient for this conversation or merge patients if needed.{t2}{t3}The primary patient helps inform suggestions when you type '@'. For example, suggestions for medications, allergies, and other patient-specific information will be based on the primary patient's records.<span className="mt-1 text-caption text-muted-foreground">This can be updated later at the top of the chat window.</span></DialogDescription></DialogHeader>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="text-body-strong text-foreground">Select Primary Patient</h3>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== chat.patients || $[6] !== onSelectPrimaryPatient || $[7] !== setIsOpen) {
    let t7;
    if ($[9] !== onSelectPrimaryPatient || $[10] !== setIsOpen) {
      t7 = patient_0 => <button key={patient_0.id} onClick={() => {
        onSelectPrimaryPatient(patient_0.id);
        setIsOpen(false);
      }} className="group flex w-full items-center justify-between rounded-lg border  p-4 text-left transition-all hover:border-border hover:bg-background-secondary"><div className="flex items-center gap-3"><div className="flex h-8 w-8 items-center justify-center rounded-full bg-muted text-caption-strong text-foreground-secondary">{formatName(patient_0.firstName, patient_0.lastName).split(" ").map(_temp2).join("").toUpperCase()}</div><span className="text-body-strong text-foreground">{formatName(patient_0.firstName, patient_0.lastName)}</span></div><svg className="h-4 w-4 text-foreground-muted group-hover:text-foreground-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></button>;
      $[9] = onSelectPrimaryPatient;
      $[10] = setIsOpen;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t6 = chat.patients.filter(_temp).map(t7);
    $[5] = chat.patients;
    $[6] = onSelectPrimaryPatient;
    $[7] = setIsOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <div className="space-y-3">{t5}<div className="space-y-2">{t6}</div></div>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider>OR</Divider>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h3 className="text-body-strong text-foreground">Merge Patients</h3>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="mb-3 text-body text-foreground-secondary">If these are the same patient, you can merge their records to consolidate their information into a single profile.</p>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="space-y-3">{t9}<div className="rounded-lg border bg-background-secondary p-4">{t10}<ProgressBarLink href="/patient/merge"><Button variant="secondary" className="w-full">Go to Merge Patients</Button></ProgressBarLink></div></div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t7) {
    t12 = <DialogBody>{t7}{t8}{t11}</DialogBody>;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== setIsOpen) {
    t13 = <DialogFooter className="mt-6"><Button variant="secondary" onClick={() => setIsOpen(false)}>Cancel</Button></DialogFooter>;
    $[20] = setIsOpen;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13) {
    t14 = <DialogContent className="sm:max-w-lg">{t4}{t12}{t13}</DialogContent>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== isOpen || $[26] !== setIsOpen || $[27] !== t14) {
    t15 = <Dialog open={isOpen} onOpenChange={setIsOpen}>{t14}</Dialog>;
    $[25] = isOpen;
    $[26] = setIsOpen;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
}
function _temp2(n) {
  return n[0];
}
function _temp(patient) {
  return !patient.isArchived;
}